var _defs, _path, _path2, _line, _line2, _line3, _line4, _line5, _line6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.6 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#e2e2e2;stroke-linecap:round;stroke-miterlimit:10;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_file") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.3,10V37.15L31.45,42H12.7V10H36.3m.92-2H11.78A1.08,1.08,0,0,0,10.7,9.08V42.92A1.08,1.08,0,0,0,11.78,44h20a1.05,1.05,0,0,0,.76-.32L38,38.29a1.05,1.05,0,0,0,.32-.76V9.08A1.08,1.08,0,0,0,37.22,8Z",
    transform: "translate(-10.7 -8)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.65,38.8,33.1,40.35V38.8h1.55m3.65-2H31.78a.67.67,0,0,0-.68.68V44h1.18l6-6V36.8Z",
    transform: "translate(-10.7 -8)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.6,
    y1: 5.4,
    x2: 18.6,
    y2: 5.4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.6,
    y1: 9,
    x2: 18.6,
    y2: 9
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.6,
    y1: 12.6,
    x2: 18.6,
    y2: 12.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.6,
    y1: 19.8,
    x2: 18.6,
    y2: 19.8
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.6,
    y1: 23.4,
    x2: 18.6,
    y2: 23.4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.6,
    y1: 27,
    x2: 18.6,
    y2: 27
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFile);
export default __webpack_public_path__ + "static/media/ic_file.9c56bed01e2916bda45e775b4860ca61.svg";
export { ForwardRef as ReactComponent };